export const getGraphHeight = (dataLength: any) => {
    return (dataLength > 2 ? dataLength * 55 : 150) + 'px ';
};
